import { createApi } from "@reduxjs/toolkit/query/react";
import { EntityAnnotationBatchToBeNormalizedDto } from "../../annotation/interfaces/annotation";
import { NormalizedOutput } from "../interfaces/normalization";
import { customBaseQuery } from "../../common/reduxQuery/helpers";
import { getBooleanFromEnv } from "../../common/utilities/env";

export interface QueryBulkArgs {
  url: string | null;
  entityAnnotationsDto: EntityAnnotationBatchToBeNormalizedDto;
}

// getBooleanFromEnv, not a string compare: appConfig.js supplies ON_PREM as a
// boolean in some environments and a string in others.
const URL_NORMALIZATION_API = getBooleanFromEnv("ON_PREM")
  ? "normalization/api/v1/batch"
  : "normalization-ai/api/v1/batch";
// const URL_NORMALIZATION_API = "shadow-proxy/api/v1/normalization"; // Shadow Testing Proxy

export const configMapApi = createApi({
  reducerPath: "configMapApi",
  baseQuery: customBaseQuery("NORMALIZATION_API"),
  endpoints: (build) => ({
    getNormalizedAnnotationBatch: build.mutation<
      Array<NormalizedOutput>,
      QueryBulkArgs
    >({
      query: ({ entityAnnotationsDto, url }) => ({
        url: url || URL_NORMALIZATION_API,
        body: entityAnnotationsDto,
        method: "POST",
      }),
    }),
  }),
});

export const { useGetNormalizedAnnotationBatchMutation } = configMapApi;
